<template>
  <div>
    <v-select
      :value="searchStatus"
      :items="statusItems"
      @change="onChange"
      class="select-box"
    />
  </div>
</template>

<script>
import { MapReportStatuses } from '@/models/MapReport'

const mapReportStatusItems = [
  { value: MapReportStatuses.Waiting, text: '発行待ち' },
  { value: MapReportStatuses.All, text: 'すべて' },
  { value: MapReportStatuses.Completed, text: '発行済' },
  { value: MapReportStatuses.Rejected, text: '却下' },
]

export default {
  name: 'AdminMapReportListSearchStatus',
  data() {
    return {
      searchStatus: MapReportStatuses.Waiting,
    }
  },
  computed: {
    statusItems() {
      return mapReportStatusItems
    },
  },
  methods: {
    onChange(status) {
      this.searchStatus = status
      this.$emit('onStatusChange', this.searchStatus)
    },
  },
}
</script>

<style>
.select-box {
  max-width: 120px;
}
</style>
